import React from 'react'
import {Col} from 'reactstrap'

const col=(props)=>(<Col {...props}/>)

export default col;